<template>
  <HeadlessLayout :sections="content" />
</template>

<script>
import SustainabilitySourcingContent from "@/content/SustainabilitySourcing.json";
import HeadlessLayout from "@/layouts/HeadlessLayout.vue";

export default {
  name: "Sourcing",
  components: {
    HeadlessLayout,
  },
  data() {
    return {
      content: SustainabilitySourcingContent,
    };
  },
};
</script>
